const afterAScamCall = {
  slug: 'after-a-scam-call',
  title: 'What to do after a suspicious or scam call',
  description:
    'Step-by-step checklist: secure accounts, change passwords, enable 2FA, monitor finances, and report the scam.',
  category: 'digital',
  guideType: 'guide',
  readMinutes: 6,
  partnerTip: 'primary',
  relatedSlugs: ['password-managers', 'password-security-basics', 'red-flags'],
  sections: [
    {
      type: 'paragraph',
      text: 'If you shared information, sent money, or installed software, act quickly. Calm, ordered steps reduce further loss.',
    },
    {
      type: 'heading',
      level: 2,
      text: '1. Stop engaging',
    },
    {
      type: 'paragraph',
      text: 'Hang up. Block the number. Do not reply to follow-up texts or emails from the same campaign.',
    },
    {
      type: 'heading',
      level: 2,
      text: '2. Secure your accounts',
    },
    {
      type: 'list',
      items: [
        'Change passwords starting with email and banking',
        'Use unique passwords — a password manager makes this practical',
        'Turn on two-factor authentication where available',
        'Check account activity and pending transfers',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: '3. Money and identity',
    },
    {
      type: 'list',
      items: [
        'Contact your bank from the number on your card if you shared banking details or sent money',
        'Place fraud alerts or credit freezes if identity documents were shared',
        'Keep notes on times, amounts, and what you were told',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: '4. Report and help others',
    },
    {
      type: 'list',
      items: [
        'Report to your national fraud authority (see regional resources)',
        'Report the phone number on WhoDatNumber so the community is informed',
        'Report to your carrier for unwanted calls or texts',
      ],
    },
    {
      type: 'partnerTip',
      partnerId: 'onePassword',
      variant: 'primary',
    },
    {
      type: 'link',
      to: '/learn/regions',
      label: 'Official reporting links by country',
    },
    {
      type: 'lookupCta',
    },
  ],
};

export default afterAScamCall;

